export default __webpack_public_path__ + "static/media/kiwi.c49ed623.png";